import React, { useState } from 'react'
import { FiPlusCircle } from 'react-icons/fi'
import { useDispatch } from 'react-redux'
import CreateReferenceModal from '../../../../components/CreateReferenceModal/CreateReferenceModal'
import { createReference, getArticleById } from '../../../../entity/volumes/Volumes'

const CreateReferenceIcon = ({ articleId }) => {
  const dispatch = useDispatch()
  const [isOpen, setIsOpen] = useState(false)

  const modalHandler = () => {
    setIsOpen(prev => !prev)
  }

  const CreateReferenceHandler = async data => {
    if (articleId && data) {
      const res = await dispatch(createReference({ articleId, referenceData: data }))

      if (createReference.fulfilled.match(res)) {
        const articleResp = await dispatch(getArticleById(articleId))
        if (articleResp.fulfilled.match(articleResp)) {
        } else {
          console.error('Error getting issue:', articleResp.payload || articleResp.error.message)
        }
        // if (res?.payload?.id) {
        //   history.push(`/volumes/${volumeId}/issue/${res?.payload?.id}`)
        // }
      } else if (createReference.rejected.match(res)) {
        console.error('Error creating issue:', res.payload || res.error.message)
      }
    }
    modalHandler()
  }

  return (
    <>
      <FiPlusCircle
        className='text-2xl hover:scale-110 transition-all cursor-pointer text-[#042A54]'
        onClick={modalHandler}
      />
      {isOpen && (
        <CreateReferenceModal
          isOpen={isOpen}
          onClose={modalHandler}
          onSubmit={CreateReferenceHandler}
        />
      )}
    </>
  )
}

export default CreateReferenceIcon
